import { render, staticRenderFns } from "./ModifierGroup.vue?vue&type=template&id=386dba12&scoped=true&"
import script from "./ModifierGroup.vue?vue&type=script&lang=js&"
export * from "./ModifierGroup.vue?vue&type=script&lang=js&"
import style0 from "./ModifierGroup.vue?vue&type=style&index=0&id=386dba12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386dba12",
  null
  
)

component.options.__file = "ModifierGroup.vue"
export default component.exports